<div class="user-modal modal fade" bsModal tabindex="-1" role="dialog" aria-labelledby="Add Users" aria-hidden="true" #usersearchmodal="bs-modal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header bg-primary text-white">
                <p class="modal-title h3">
                    <strong *ngIf="!includeGroups">Add users to</strong>
                    <strong *ngIf="includeGroups">Add users/groups to</strong>
                    "{{containerName}}"
                </p>
                <button type="button" class="btn btn-sm btn-primary" aria-label="Close" (click)="closeModal()">
                  <span aria-hidden="true"><i class="fa fa-close"></i></span>
                </button>
            </div>
            <div class="modal-body modal-border p-0">
                <input class="form-control mt-0 border-0 pt-3 pb-3" [formControl]="searchTerm"  placeholder="Search name or email" />

                <div class="bg-faded">
                    <div class="row">
                        <div class="col">

                            <small class="ml-3 mt-3 d-block text-muted" *ngIf="!loading && userHasSearched">{{usersFound?.length}} user(s) found
                            </small>
                            
                            <small class="ml-3 mt-3 d-block text-muted" *ngIf="loading">
                                <em>
                                    Searching...
                                </em>
                            </small>

                            <div class="pl-3 pr-3 mt-3 user-list">
                                <div *ngFor="let user of usersFound">
                                    <div class="list-group-item mb-1 pt-2 pb-2 justify-content-between"  [ngClass]="{'list-group-item-info': user.selected}">
                                        <span>
                                            <i class="fa mr-2" [ngClass]="user.email ? 'fa-user' : 'fa-group'"></i>{{user.name}} <em *ngIf="user.email">({{user.email}})</em>
                                        </span>

                                        <input type="checkbox" [(ngModel)]="user.selected" (change)="userSelected(user)" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                     <div class="p-3" *ngIf="usersSelected.length > 0">
                        <div class="row">
                            <div class="col-12">
                                <small class="d-block mb-2"><strong>Selected users:</strong></small>
                                <div class="badge badge-info btn-sm mr-2" *ngFor="let user of usersSelected">
                                    <span>{{user.name}}</span>
                                    <i class="fa fa-close ml-2" role="button" (click)="removeSelectedUser(user)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer bg-faded text-muted">
                <button class="btn btn-primary ml-2 btn-sm" [disabled]="usersSelected.length == 0" (click)="addUsers()">
                    Add {{usersSelected.length}} {{ includeGroups ? "user(s)/group(s)" : "user(s)"}}
                </button>
            </div>
        </div>
    </div>
</div>




